import { useNavigate } from 'react-router-dom'
import { SubmitHandler } from 'react-hook-form'
import { useSetRecoilState } from 'recoil'
import { activeStepState } from '../../../store/atoms/active-step'
import { useEffect } from 'react'
import {
  CreateCampaignType,
  CreateCampaignSchema,
} from '@/schema/campaign-details.schema'
import CampaignDetailsForm from './form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCampaignClient } from '@/lib/api'
import { invalidateCampaignQueries } from '@/lib/cache-utils'

export default function CreateCampaign() {
  const queryClient = useQueryClient()
  const campaignClient = useCampaignClient()
  const setActiveStep = useSetRecoilState(activeStepState)
  const navigate = useNavigate()
  useEffect(() => setActiveStep(1), [setActiveStep])

  const createCampaignMutation = useMutation({
    mutationFn: (campaign: CreateCampaignType) =>
      campaignClient.createCampaign.mutate({
        body: campaign,
      }),
  })

  const onSubmit: SubmitHandler<CreateCampaignType> = (data, e) => {
    const buttonName = (
      (e?.nativeEvent as SubmitEvent) || undefined
    )?.submitter?.getAttribute('name')

    createCampaignMutation.mutate(data, {
      onSuccess: (response) => {
        if (response.status === 200) {
          const campaignId = response.body.id
          invalidateCampaignQueries(queryClient, campaignId)

          if (buttonName === 'next') {
            navigate(`/campaigns/questionnaire/${campaignId}`)
          } else {
            navigate(`/campaigns/details/${campaignId}`)
          }
        }
      },
      onError: (error) => {
        console.error('Failed to create campaign:', error)
      },
    })
  }

  return (
    <CampaignDetailsForm onSubmit={onSubmit} schema={CreateCampaignSchema} />
  )
}
